import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaMoneyBillWaveAlt, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./amortizacion.module.css";
import { IoCloseSharp, IoPersonAddSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select';
import ReactStars from "react-rating-stars-component";

export default function Amortizacion(props) {
    const { show, setShow, prestamoActual, setPrestamoActual, showAmorT, setShowAmorT, handleUpdate, isReadOnlyMode: isReadOnlyFromParent } = props;
    const { clientActual, userId,permisos } = useAuth();
    const isReadOnlyMode = typeof isReadOnlyFromParent === 'boolean'
        ? isReadOnlyFromParent
        : permisos.findIndex(item => item.identifier === "PrestReadMode") !== -1;
    const [total, setTotal] = useState(0);
    const [showPago, setShowPago] = useState(false);
    const [tableFront, setTableFront] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loanFines, setLoanFines] = useState([]);
    const [totalFines, setTotalFines] = useState(0);
    const [paymentsIds, setPaymentsIds] = useState([]);
    const [cantidadPagos, setCantidadPagos] = useState([]);
    const [update, setUpdate] = useState(1);
    const [liquidar, setLiquidar] = useState(false);
    const [pagoSelect, setPagoSelect] = useState({ value: 1, label: 1 });
    const [tipePayment, setTipePayment] = useState("PAG");
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [tableKey, setTableKey] = useState(0); // Agregar un estado para forzar re-render de la tabla
    const [availablePayments, setAvailablePayments] = useState([]);
    const [selectedSpecificPayment, setSelectedSpecificPayment] = useState(null);
    const [showPaymentSelector, setShowPaymentSelector] = useState(false);
    const [canLiquidate, setCanLiquidate] = useState(false);
    const [liquidationBlockMessage, setLiquidationBlockMessage] = useState('');
    const [evaluation, setEvaluation] = useState(prestamoActual?.evaluation);
    const [renderKey, setRenderKey] = useState(0);

    const formatFolio = (number, totalDigits = 6) => {
        if (number === null || number === undefined) return 'N/A';
        const numberStr = number.toString();
        const zerosNeeded = Math.max(0, totalDigits - numberStr.length);
        const zeros = '0'.repeat(zerosNeeded);
        return `F-${zeros}${numberStr}`;
    };

    const summaryMetrics = useMemo(() => {
        const toDateOnly = (dateValue) => {
            if (!dateValue) return null;
            if (typeof dateValue === 'string') {
                if (dateValue.includes('T')) return dateValue.split('T')[0];
                if (dateValue.includes(' ')) return dateValue.split(' ')[0];
                return dateValue;
            }

            return new Date(dateValue).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-');
        };

        const getTimingKey = (scheduledDate, paymentDate) => {
            const scheduled = toDateOnly(scheduledDate);
            const paid = toDateOnly(paymentDate);

            if (!scheduled || !paid) return 'enTiempo';
            if (paid < scheduled) return 'adelantados';
            if (paid > scheduled) return 'atrasados';
            return 'enTiempo';
        };

        const result = {
            pagos: {
                enTiempo: 0,
                atrasados: 0,
                adelantados: 0
            },
            abonos: {
                enTiempo: 0,
                atrasados: 0,
                adelantados: 0
            }
        };

        if (!tableData || tableData.length === 0) return result;

        tableData.forEach((amortizationRow) => {
            const rowAmount = Number(amortizationRow.amount || 0);
            const payments = amortizationRow.payments || [];

            payments.forEach((payment) => {
                const paymentType = (payment.paymentType || '').toUpperCase();
                const paymentAmount = Number(payment.paymentAmount || 0);
                const isAbono = paymentType.includes('ABON') || (rowAmount > 0 && paymentAmount < rowAmount);
                const timingKey = getTimingKey(amortizationRow.date, payment.paymentDate);

                if (isAbono) {
                    result.abonos[timingKey] += 1;
                } else {
                    result.pagos[timingKey] += 1;
                }
            });
        });

        return result;
    }, [tableData]);

    const totalAdeudo = useMemo(() => {
        if (!tableData || tableData.length === 0) return prestamoActual?.amount || 0;
        return tableData.reduce((sum, payment) => sum + (Number(payment.amountR || 0)), 0);
    }, [tableData, prestamoActual?.amount]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const handleTogglePago = () => {
        if (isReadOnlyMode) return;
        if (showPago && tipePayment === "PAG") {
            setShowPago(false);
        } else {
            setShowPago(true);
            setTipePayment("PAG");
        }
        // Forzar re-render de la tabla después de un breve delay
        setTimeout(() => setTableKey(prev => prev + 1), 350);
    };

    const handleToggleAportacion = () => {
        if (isReadOnlyMode) return;
        if (showPago && tipePayment === "ASE") {
            setShowPago(false);
        } else {
            setShowPago(true);
            setTipePayment("ASE");
        }
        // Forzar re-render de la tabla después de un breve delay
        setTimeout(() => setTableKey(prev => prev + 1), 350);
    };
    const conditionalRowStyles = [
        {
            when: row => row.select,
            style: {
                backgroundColor: '#EEEEEE'
            },
        },
    ];
    const columns = [
        {
            name: '#',
            selector: row => row.number,
            minWidth: "80px"
        },
        {
            name: 'Estatus',
            cell: (row) => {
                return (
                    <>
                        <span className={row.badgeClass}>{row.badgeStatus}</span>&nbsp;
                        {
                            (
                                !isReadOnlyMode && row.advisorContributions && row.advisorContributions.length > 0 ?
                                    <span className="badge bg-primary"><IoPersonAddSharp /></span>
                                    : <></>
                            )
                        }
                    </>
                )

            },
            minWidth: "120px"
        },
        {
            name: 'Fecha de Pago',
            selector: row => row.date.split("T")[0],

            minWidth: "140px"
        },
        {
            name: 'Monto',
            selector: row => `$ ${row.amount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            minWidth: "140px"
        },
        {
            name: 'Monto restante',
            selector: row => `$ ${row.amountR.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            minWidth: "150px"
        },
        {
            name: 'Multas',
            selector: row => row.finesTotal || 0,
            cell: row => (`$ ${Number(row.finesTotal || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
            minWidth: '120px'
        },
        {
            name: 'Aporte asesor',
            selector: row => `$ ${row.amountA.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
            minWidth: "150px",
            omit: isReadOnlyMode
        },
        {
            name: 'Pagos',
            selector: row => row.payments.length,
            minWidth: "80px"
        },



    ];
    const checkLiquidationAvailability = (loans) => {
        // Verificar si se puede liquidar basado en LiquidationDay
        if (!prestamoActual || !prestamoActual.liquidationDay || !loans || loans.length === 0) {
            setCanLiquidate(false);
            setLiquidationBlockMessage('');
            return;
        }
        
        const liquidationDayNumber = prestamoActual.liquidationDay;
        const criticalPayment = loans.find(payment => payment.number === liquidationDayNumber);
        
        if (!criticalPayment) {
            setCanLiquidate(false);
            setLiquidationBlockMessage(`No se encontró el pago #${liquidationDayNumber}`);
            return;
        }
        
        // Obtener la fecha del pago crítico
        const criticalPaymentDate = new Date(criticalPayment.date);
        const todayDate = new Date();
        
        // Comparar fechas (ignorando la hora)
        const criticalPaymentDateOnly = new Date(criticalPaymentDate.getFullYear(), criticalPaymentDate.getMonth(), criticalPaymentDate.getDate());
        const todayDateOnly = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate());
        
        if (todayDateOnly > criticalPaymentDateOnly) {
            // La fecha actual es posterior a la fecha del pago crítico
            setCanLiquidate(true);
            setLiquidationBlockMessage('');
        } else {
            // Aún no se puede liquidar
            setCanLiquidate(false);
            const paymentDateFormatted = criticalPayment.date.split("T")[0];
            setLiquidationBlockMessage(`No puede liquidar hasta después del ${paymentDateFormatted} (Pago #${liquidationDayNumber})`);
        }
    }

    const handleUpdatepdateTable = () => {
        api(SERVICE.getTableAmor + prestamoActual.id)
            .then((data) => {
                let arrayTemp = [];
                let arrayTemp2 = [];
                if (data.data.data) {
                    let contador = 0;
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        let totalP = 0;
                        let totalA = 0;
                        if (element.payments.length === 0) {
                            contador = contador + 1;
                        }
                        else {
                            for (let index = 0; index < element.payments.length; index++) {
                                const itemPayment = element.payments[index];
                                totalP = totalP + itemPayment.paymentAmount;
                            }
                        }
                        if (element.advisorContributions) {
                            for (let index = 0; index < element.advisorContributions.length; index++) {
                                const itemPayment = element.advisorContributions[index];
                                totalA = totalA + itemPayment.advisorContributionAmount;
                            }
                        }
                        totalP = (element.amount - totalP);
                        let color = "";
                        let badge = (
                            <div className={styles.itemTable}>
                                <span class="badge bg-secondary">POR PAGAR</span>
                            </div>
                        );
                        let badgeStatus = "POR PAGAR";
                        let badgeClass = "badge bg-secondary";
                        if (element.payments.length > 0) {
                            if (totalP > 0) {
                                badge = (
                                    <div className={styles.itemTable}>
                                        <span class="badge bg-warning">PARCIAL</span>
                                    </div>
                                );
                                badgeStatus = "PARCIAL";
                                badgeClass = "badge bg-warning";
                            }
                            else {
                                badge = (
                                    <div className={styles.itemTable}>
                                        <span class="badge bg-success">PAGADO</span>
                                    </div>
                                );
                                badgeStatus = "PAGADO";
                                badgeClass = "badge bg-success";
                            }

                        }
                        else {
                            // Comparar fechas como strings para evitar problemas de zona horaria
                            const fechaElemento = element.date.split('T')[0]; // Obtener solo la parte de fecha YYYY-MM-DD
                            const fechaHoy = new Date().toLocaleDateString('es-MX', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                timeZone: 'America/Mexico_City'
                            }).split('/').reverse().join('-'); // Formato YYYY-MM-DD
                            
                            if (fechaElemento < fechaHoy) {
                                badge = (
                                    <div className={styles.itemTable}>
                                        <span class="badge bg-danger">VENCIDO</span>
                                    </div>
                                );
                                badgeStatus = "VENCIDO";
                                badgeClass = "badge bg-danger";
                            }
                        }
                        arrayTemp2.push(
                            {
                                ...element,
                                badgeClass: badgeClass,
                                badgeStatus: badgeStatus,
                                amountR: totalP,
                                amountA: totalA,
                                select: false
                            }
                        );
                        arrayTemp.push(
                            <div className={styles.rowTable} style={{ backgroundColor: color }}>
                                <div className={styles.itemTable}>
                                    {element.number}
                                </div>
                                <div className={styles.itemTable}>
                                    {element.date.split("T")[0]}
                                </div>
                                <div className={styles.itemTable}>
                                    {`$ ${element.amount.toLocaleString('es-MX', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`}
                                </div>
                                {badge}
                            </div>
                        );
                    }
                    let arrayPrestamos = [];
                    for (let index = 1; index <= contador; index++) {
                        arrayPrestamos.push({
                            value: index,
                            label: index
                        })
                    }
                    
                    setCantidadPagos(arrayPrestamos);
                }
                // Primero asignar vista y estructura básica
                setTableFront(arrayTemp);

                // Obtener multas del préstamo y anexarlas a cada pago
                api(SERVICE.getbyLoanId + prestamoActual.id)
                    .then((fdata) => {
                        const fines = (fdata && fdata.data && fdata.data.data) ? fdata.data.data : [];
                        setLoanFines(fines);
                        const total = fines.reduce((s, it) => s + (Number(it.amount || 0)), 0);
                        setTotalFines(total);

                        const enhanced = arrayTemp2.map(el => {
                            const finesFor = fines.filter(f => Number(f.amortizationTableId) === Number(el.id));
                            const finesTotal = finesFor.reduce((s, it) => s + (Number(it.amount || 0)), 0);
                            return {
                                ...el,
                                fines: finesFor,
                                finesTotal: finesTotal
                            };
                        });

                        setTableData(enhanced);
                        // Verificar disponibilidad de liquidación usando la data mejorada
                        checkLiquidationAvailability(enhanced);
                    })
                    .catch((err) => {
                        console.log('Error fetching fines', err);
                        setLoanFines([]);
                        setTotalFines(0);
                        setTableData(arrayTemp2);
                        checkLiquidationAvailability(arrayTemp2);
                    });
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleDelete = (id, paymentType = "Pago") => {
        if (isReadOnlyMode) return;

        const isAdvisorContribution = paymentType === "Aportación Asesor";
        Swal.fire({
            title: isAdvisorContribution
                ? "Esta segur@ que desea eliminar la aportación de asesor?"
                : "Esta segur@ que desea eliminar el pago?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                api(SERVICE.deletePayment + `?PaymentsId=${id}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                        handleUpdatepdateTable();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });
    }

    const handlePagar = () => {
        if (isReadOnlyMode) return;

        if (fecha != null && fecha != "") {
            // Verificar si se requiere selección específica pero no se ha hecho
            if (showPaymentSelector && !selectedSpecificPayment && paymentsIds.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selección requerida',
                    text: 'Por favor seleccione un pago específico de la lista o ajuste el monto para continuar.',
                    confirmButtonText: 'Entendido'
                });
                return;
            }

            if (tipePayment === "PAG") {
                const paymentText = selectedSpecificPayment 
                    ? `Se realizará un pago específico al Pago #${selectedSpecificPayment.paymentData.number}` 
                    : `Se Realizará un pago${paymentsIds.length > 1 ? ` de ${paymentsIds.length} cuotas` : ''}`;
                
                Swal.fire({
                    title: `<div>${paymentText} por la cantidad de <b>$ ${total.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</b></div>`,
                    showCancelButton: true,
                    confirmButtonText: "PAGAR",
                    confirmButtonColor: "#079459",
                    cancelButtonText: "CANCELAR"
                }).then((result) => {
                    if (result.isConfirmed) {
                        debugger;
                        let payload = [];

                        for (let index = 0; index < paymentsIds.length; index++) {
                            const element = paymentsIds[index];
                            // Comparar fechas como strings para evitar problemas de zona horaria
                            const fechaElemento = element.date.split('T')[0]; // Obtener solo la parte de fecha YYYY-MM-DD
                            const fechaPago = fecha; // Ya está en formato YYYY-MM-DD
                            
                            let tipoPago = "";
                            if (liquidar) {
                                tipoPago = "PAGTOTAL";
                            }
                            else {
                                if (fechaElemento < fechaPago) {
                                    tipoPago = "PAGATR";
                                }
                                else if (fechaElemento > fechaPago) {
                                    tipoPago = "PAGADE";
                                }
                                else {
                                    tipoPago = "PAG";
                                }
                            }
                            if (element.montoPago < element.amount) {
                                if (fechaElemento < fechaPago) {
                                    tipoPago = "PAGABONATR";
                                }
                                else{
                                    tipoPago = "PAGABON";
                                }
                                
                            }

                            payload.push(
                                {
                                    "TypePaymentIdentifier": tipoPago,
                                    "AmortizationTableId": element.id,
                                    "Amount": element.montoPago,
                                    "Date": fecha,
                                    "UserId": userId,
                                }
                            );

                        }
                        api(SERVICE.setPago, payload, "POST")
                            .then((data) => {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Pagos realizados correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                
                                handleUpdate();
                                handleUpdateByTotal(total);
                                //setUpdate(update+1);
                                setTimeout(() => handleUpdatepdateTable(), 500);
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    }
                });
            }
            else {
                Swal.fire({
                    title: "<div>Se Realizará una aportación por la cantidad de <b>$ " + total.toLocaleString('es-MX', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) + "</b></div>",
                    showCancelButton: true,
                    confirmButtonText: "APORTAR",
                    confirmButtonColor: "#0d6efd",
                    cancelButtonText: "CANCELAR"
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {

                        let arrayTemp = [];
                        for (let index = 0; index < paymentsIds.length; index++) {
                            const element = paymentsIds[index];
                            arrayTemp.push(
                                {
                                    "AmortizationTableId": element.id,
                                    "Amount": element.montoPago
                                }
                            );
                        }
                        let payload = {
                            "LoanId": prestamoActual.id,
                            "Date": fecha,
                            "Amount": total,
                            "Details": arrayTemp
                        };
                        api(SERVICE.setAportacion, payload, "POST")
                            .then((data) => {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Aportación realizada correctamente",
                                    showConfirmButton: false,
                                    timer: 1500
                                });
                                handleUpdatepdateTable();
                                handleUpdate();
                                handleUpdateByTotal(total);
                                //setUpdate(update+1);
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    }
                });
            }


        }
        else {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }

    }
    const handleSpecificPaymentSelection = (selectedOption) => {
        setSelectedSpecificPayment(selectedOption);
        
        if (selectedOption) {
            let dataTemp = [...tableData];
            const paymentData = selectedOption.paymentData;
            
            // Limpiar todas las selecciones
            dataTemp.forEach((element, index) => {
                dataTemp[index].select = false;
            });
            
            // Seleccionar solo el pago específico
            const paymentIndex = dataTemp.findIndex(p => p.id === paymentData.id);
            if (paymentIndex !== -1) {
                dataTemp[paymentIndex].select = true;
                
                // El monto a pagar será el menor entre: el total ingresado o el monto restante del pago
                // Esto permite pagos parciales cuando el monto es menor al monto restante
                const montoPago = Math.min(total, paymentData.amountR);
                setPaymentsIds([{
                    ...paymentData,
                    montoPago: montoPago
                }]);
            }
            
            setTableData(dataTemp);
        } else {
            // Si no hay selección, limpiar todo
            let dataTemp = [...tableData];
            dataTemp.forEach((element, index) => {
                dataTemp[index].select = false;
            });
            setTableData(dataTemp);
            setPaymentsIds([]);
        }
    };

    const handleUpdateByTotal = (totalAr) => {
        const newValue = parseFloat(totalAr)
        setTotal(newValue);
        setLiquidar(false);
        let dataTemp = [...tableData];
        
        let shouldShowSelector = (pagoSelect.value === 1 || pagoSelect.value === undefined) && newValue > 0 && !liquidar;
        let paymentIndex = dataTemp.findIndex(payment =>  newValue <= payment.amountR && payment.amountR > 0);
        if (paymentIndex === -1) {
            shouldShowSelector = false;
        }
        
        if (shouldShowSelector) {
            const pendingPayments = dataTemp.filter(payment => payment.amountR > 0 && newValue <= payment.amountR);
            
            // Crear opciones para TODOS los pagos pendientes (no solo los que se pueden cubrir completamente)
            const allPaymentOptions = pendingPayments.map(payment => ({
                value: payment.id,
                label: `Pago #${payment.number} - ${payment.date.split("T")[0]} - $${payment.amountR.toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`,
                paymentData: payment
            }));
            
            setAvailablePayments(allPaymentOptions);
            
            // Calcular cuántos pagos se cubrirían automáticamente con el monto
            let totalCoveredAutomatically = 0;
            let paymentsCoveredCount = 0;
            
            for (const payment of pendingPayments) {
                if (totalCoveredAutomatically + payment.amountR <= newValue) {
                    totalCoveredAutomatically += payment.amountR;
                    paymentsCoveredCount++;
                } else {
                    break;
                }
            }
            
            // Mostrar selector si hay pagos pendientes Y:
            // - El monto cubre 0 pagos completos (pago parcial), O
            // - El monto cubre exactamente 1 pago Y hay más opciones, O  
            // - Siempre mostrar si hay múltiples opciones de pago disponibles
            const shouldShow = allPaymentOptions.length > 0 && 
                              (paymentsCoveredCount === 0 || 
                               (paymentsCoveredCount === 1 && allPaymentOptions.length > 1) ||
                               allPaymentOptions.length > paymentsCoveredCount);
            
            setShowPaymentSelector(shouldShow);
            
            // Si debe mostrar selector, limpiar selección automática
            if (shouldShow) {
                dataTemp.forEach((element, index) => {
                    dataTemp[index].select = false;
                });
                setTableData(dataTemp);
                setPaymentsIds([]);
                setSelectedSpecificPayment(null);
                return;
            }
        } else {
            setShowPaymentSelector(false);
            setSelectedSpecificPayment(null);
        }
        
        if (dataTemp.length > 0 && showPago) {
            let totaldisp = totalAr;
            let dataSelect = [];

            for (let index = 0; index < dataTemp.length; index++) {
                const element = dataTemp[index];
                let color = false;

                if (element.payments.length === 0 || element.amountR > 0) {
                    if (totaldisp >= element.amountR) {
                        totaldisp = totaldisp - element.amountR;
                        color = true;
                        dataSelect.push(
                            {
                                ...element,
                                montoPago: element.amountR
                            }
                        );
                    }
                    else if (totaldisp < element.amountR && totaldisp !== 0) {
                        color = true;
                        dataSelect.push(
                            {
                                ...element,
                                montoPago: totaldisp
                            }
                        );
                        totaldisp = 0;
                    }
                    else {
                        color = false;
                    }
                }

                dataTemp[index].select = color;
            }
            console.log("dataTemp", dataTemp);
            setTableData(dataTemp);
            setPaymentsIds(dataSelect);
        }
    }

const handleChangeEvaluation = (newRating) => {   
     Swal.fire({
                title: "¿Está segur@ que desea guardar la evaluación del préstamo?",
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#198754",
                cancelButtonColor: "#d33"
            }).then((result) => {
                if (result.isConfirmed) {
                    api(SERVICE.setEvaluationLoan+ `?Id=${prestamoActual.id}&Evaluation=${newRating}`)
                        .then((data) => {
                            Swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Préstamo evaluado correctamente",
                                showConfirmButton: false,
                                timer: 1500
                            });
                            setEvaluation(newRating);
                            setPrestamoActual({
                                ...prestamoActual,
                                evaluation:newRating
                            });
                            handleUpdate();
                            handleUpdatepdateTable();

                        })
                        .catch((err) => {
                            console.log(err);
                            Swal.fire({
                                position: "center",
                                icon: "error",
                                title: "Error al evaluar el préstamo",
                                text: "Por favor intente de nuevo",
                                showConfirmButton: true
                            });
                        })
                }else{
                      setEvaluation(prestamoActual?.evaluation);
                      setRenderKey(prev => prev + 1);
                }
            });
        

    };
useEffect(() => {
    setEvaluation(prestamoActual?.evaluation || 0);
  }, [prestamoActual]);

    useEffect(() => {
        console.log("prestamoActual", prestamoActual)

        if (show && !showPago) {
            if (prestamoActual !== null) {
                handleUpdatepdateTable();
            }
        }
        if (!show) {
            setFecha(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-'));
            setPagoSelect({ value: 1, label: 1 });
            setShowPago(false); // Asegurar que se oculte al cerrar
            setShowPaymentSelector(false);
            setSelectedSpecificPayment(null);
            setAvailablePayments([]);
        }
    }, [prestamoActual, show])

    useEffect(() => {
        // Limpiar selección específica cuando cambie el número de pagos o liquidar
        setShowPaymentSelector(false);
        setSelectedSpecificPayment(null);
        setAvailablePayments([]);

        let dataTemp = [...tableData];
        if (dataTemp.length > 0 && showPago) {
            let totalTemp = 0;
            let contador1 = 0;
            let dataSelect = [];
            for (let index = 0; index < dataTemp.length; index++) {
                const element = dataTemp[index];
                if (element.payments.length === 0 || element.amountR > 0) {
                    totalTemp = totalTemp + element.amountR;
                    contador1 = contador1 + 1;
                }
                if (contador1 == pagoSelect.value) {
                    if (!liquidar) {
                        break;
                    }
                }
            }
            // Si es 1 pago, calcular solo el primer pago pendiente, no la suma total
            if (pagoSelect.value === 1 && !liquidar) {
                // Buscar el primer pago pendiente
                const firstPendingPayment = dataTemp.find(payment => payment.payments.length === 0 || payment.amountR > 0);
                const singlePaymentTotal = firstPendingPayment ? firstPendingPayment.amountR : totalTemp;
                
                setTotal(singlePaymentTotal);
                
                // Activar lógica del selector
                setTimeout(() => handleUpdateByTotal(singlePaymentTotal), 100);
                return; // No continuar con la lógica normal
            } else {
                setTotal(totalTemp);
            }
            
            let arrayTemp = [];

            contador1 = 0;
            for (let index = 0; index < dataTemp.length; index++) {
                const element = dataTemp[index];
                let color = false;

                if ((element.payments.length === 0 || element.amountR > 0) && (liquidar || (contador1 < pagoSelect.value))) {
                    contador1 = contador1 + 1;
                    color = true;
                    dataSelect.push(
                        {
                            ...element,
                            montoPago: element.amountR
                        }
                    );
                }
                

                dataTemp[index].select = color;

            }
            console.log("dataTemp", dataTemp);
            setTableFront(arrayTemp);
            setTableData(dataTemp);
            setPaymentsIds(dataSelect);
        }
    }, [pagoSelect, liquidar, showPago, update])
    useEffect(() => {
        if (showAmorT) {
            setShowPago(true);
        }
    }, [showAmorT])
    useEffect(() => {
        console.log("paymentsIds", paymentsIds)
    }, [paymentsIds])
    const ExpandedComponent = ({ data }) => {
        // Columnas para la sub-tabla de pagos
        let arrayTemp = [...data.payments];
        if (!isReadOnlyMode) {
            for (let index = 0; index < data.advisorContributions.length; index++) {
                const element = data.advisorContributions[index];
                arrayTemp.push({
                    paymentId: element.advisorContributionId,
                    paymentAmount: element.advisorContributionAmountDetail,
                    paymentDate: element.advisorContributionDate,
                    paymentType: "Aportación Asesor"
                })
            }
        }

        const paymentColumns = [
            {
                name: "ID",
                selector: (row) => row.paymentId,
                sortable: true,
            },
            {
                name: "Monto",
                selector: row => `$ ${row.paymentAmount.toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`,
                sortable: true,
            },
            {
                name: "Fecha",
                selector: row => row.paymentDate.split("T")[0],
                sortable: true,
            },
            {
                name: "Tipo",
                selector: (row) => row.paymentType,
                sortable: true,
                minWidth: '150px'
            },
            ...(!isReadOnlyMode ? [
                {
                    name: 'Acciones',
                    cell: row => (
                        <div>
                            <button
                                className={row.paymentType === "Aportación Asesor" ? 'btn btn-sm btn-warning' : 'btn btn-sm btn-danger'}
                                onClick={() => handleDelete(row.paymentId, row.paymentType)}
                                title={row.paymentType === "Aportación Asesor" ? "Eliminar aportación" : "Eliminar pago"}
                            >
                                <MdDelete />
                            </button>
                        </div>
                    ),
                    wrap: true,
                    minWidth: '150px'

                },
            ] : []),
        ];

        return (
            <div style={{ padding: "10px", backgroundColor: "#f9f9f9" }}>
                <div className={styles.titleSub}>Historial de Pagos</div>
                <DataTable
                    columns={paymentColumns}
                    data={arrayTemp || []} // Usa los pagos del registro principal
                    customStyles={APP_OPTIONS.TABLE_SETTING} // Mismo estilo que la tabla principal
                    noDataComponent="No hay pagos registrados"
                />
                {data.fines && data.fines.length > 0 && (
                    <div style={{ marginTop: 12 }}>
                        <div className={styles.titleSub}>Multas asociadas a este pago</div>
                        <ul className="list-group">
                            {data.fines.map(f => (
                                <li className="list-group-item d-flex justify-content-between align-items-center" key={f.id}>
                                    <div>
                                        <div><strong>${Number(f.amount).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
                                        <div className="text-muted" style={{ fontSize: '12px' }}>{f.date ? f.date.split('T')[0] : ''}</div>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '12px' }}>ID: {f.id}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} ${showPago ? styles.withPanel : ''} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>Tabla de amortización</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={`${styles.containerForm} ${showPago ? styles.withPaymentPanel : ''}`}>
                        <div className={styles.tableSection}>
                            <div className={styles.loanSummaryHeader}>
                                <div className={styles.loanSummaryMain}>
                                    <div className={styles.loanSummaryItem}>
                                        <span className={styles.loanSummaryLabel}>Cliente</span>
                                        <span className={styles.loanSummaryValue}>{prestamoActual?.clientName || 'N/A'}</span>
                                    </div>
                                    <div className={styles.loanSummaryItem}>
                                        <span className={styles.loanSummaryLabel2}>Folio</span>
                                        <span className={styles.loanSummaryValue2}>{formatFolio(prestamoActual?.id)}</span>
                                    </div>
                                    <div className={styles.loanSummaryItem}>
                                        <span className={styles.loanSummaryLabel}>Monto préstamo</span>
                                        <span className={styles.loanSummaryValue}>$ {(prestamoActual?.amount || 0).toLocaleString('es-MX', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}</span>
                                    </div>
                                    <div className={styles.loanSummaryItem}>
                                        <span className={styles.loanSummaryLabel}>Deuda</span>
                                        <span className={styles.loanSummaryValue}>$ {(totalAdeudo || 0).toLocaleString('es-MX', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}</span>
                                    </div>
                                    <div className={styles.loanSummaryItem}>
                                        <span className={styles.loanSummaryLabel}>Evaluación</span>
                                        <div className={styles.loanSummaryItem2}>
                                            <ReactStars
                                                key={`stars-${prestamoActual?.id}-${evaluation}-${renderKey}`}
                                                count={5}
                                                onChange={handleChangeEvaluation}
                                                size={24}
                                                value={evaluation}
                                                isHalf={true}
                                                emptyIcon={<i className="far fa-star"></i>}
                                                halfIcon={<i className="fa fa-star-half-alt"></i>}
                                                fullIcon={<i className="fa fa-star"></i>}
                                                activeColor="#ffd700"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.loanSummaryGrid}>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Pagos en tiempo</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.pagos.enTiempo}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Pagos atrasados</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.pagos.atrasados}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Pagos adelantados</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.pagos.adelantados}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Abonos en tiempo</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.abonos.enTiempo}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Abonos atrasados</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.abonos.atrasados}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Abonos adelantados</span>
                                        <span className={styles.loanSummaryCardValue}>{summaryMetrics.abonos.adelantados}</span>
                                    </div>
                                    <div className={styles.loanSummaryCard}>
                                        <span className={styles.loanSummaryCardTitle}>Total Multas</span>
                                        <span className={styles.loanSummaryCardValue}>${Number(totalFines || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </div>
                                </div>
                            </div>

                            {!isReadOnlyMode && (
                                <div className={styles.actionButtons}>
                                    <button className='btn btn-success' onClick={handleTogglePago}>
                                        Realizar Pago&nbsp;&nbsp;<FaMoneyBillWaveAlt />
                                    </button>
                                    {prestamoActual && prestamoActual.typeClient === "CLT" && (
                                        <button className='btn btn-primary' onClick={handleToggleAportacion}>
                                            Aportación Asesor&nbsp;&nbsp;<FaUserFriends />
                                        </button>
                                    )}
                                    
                                </div>
                            )}
                            <div className={styles.tableContainer}>
                                <DataTable
                                    key={tableKey} // Agregar key para forzar re-render
                                    columns={columns}
                                    data={tableData}
                                    customStyles={APP_OPTIONS.TABLE_SETTING2}
                                    persistTableHead
                                    fixedHeader
                                    fixedHeaderScrollHeight='400px'
                                    responsive
                                    conditionalRowStyles={conditionalRowStyles}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                />
                            </div>
                        </div>

                        {showPago && !isReadOnlyMode && (
                            <div className={`${styles.paymentSection} ${styles.show}`}>
                                <div className={styles.paymentForm}>
                                    <h4>{tipePayment === "PAG" ? "Realizar Pago" : "Aportación Asesor"}</h4>

                                    {tipePayment !== "PAG" && (
                                        <div className={styles.formGroup}>
                                            <label className="form-label">Asesor:</label>
                                            <input disabled type="text" className="form-control" value={prestamoActual?.advisorName || ''} />
                                        </div>
                                    )}

                                    {/* Resto del formulario... */}
                                    <div className={styles.formGroup}>
                                        <label className="form-label">
                                            {tipePayment === "PAG" ? "Fecha de pago" : "Fecha de aportación"}:
                                        </label>
                                        <input
                                            min={permisos.findIndex(item => item.identifier === "ApplyAnyDate") === -1 ? 
                                                new Date().toLocaleDateString('es-MX', {
                                                    year: 'numeric',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    timeZone: 'America/Mexico_City'
                                                }).split('/').reverse().join('-') : undefined}
                                            type="date"
                                            className="form-control"
                                            value={fecha}
                                            onChange={(e) => setFecha(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.formGroup} style={{ zIndex: 4 }}>
                                        <label className="form-label">Cantidad de pagos:</label>
                                        <Select
                                            isDisabled={liquidar}
                                            options={cantidadPagos}
                                            value={pagoSelect}
                                            onChange={(e) => {
                                                setPagoSelect(e);
                                                
                                            }}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    minHeight: '38px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ced4da',
                                                    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
                                                    '&:hover': {
                                                        borderColor: '#ced4da'
                                                    }
                                                }),
                                                container: (provided) => ({
                                                    ...provided,
                                                    border: 'none',
                                                    padding: 0,
                                                    margin: 0
                                                })
                                            }}
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label className="form-label">
                                            {tipePayment === "PAG" ? "Monto total" : "Monto aportación"}:
                                        </label>
                                        <input
                                            disabled={liquidar}
                                            type="number"
                                            className="form-control"
                                            placeholder="$"
                                            value={total}
                                            onChange={(e) => handleUpdateByTotal(e.target.value)}
                                        />
                                    </div>

                                    {showPaymentSelector && tipePayment === "PAG" && (
                                        <div className={styles.formGroup} style={{ zIndex: 3 }}>
                                            <label className="form-label">Seleccionar pago específico:</label>
                                            <Select
                                                isClearable
                                                options={availablePayments}
                                                value={selectedSpecificPayment}
                                                onChange={handleSpecificPaymentSelection}
                                                placeholder="Seleccione un pago específico..."
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        minHeight: '38px',
                                                        borderRadius: '6px',
                                                        border: '1px solid #ced4da',
                                                        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
                                                        '&:hover': {
                                                            borderColor: '#ced4da'
                                                        }
                                                    }),
                                                    container: (provided) => ({
                                                        ...provided,
                                                        border: 'none',
                                                        padding: 0,
                                                        margin: 0
                                                    })
                                                }}
                                            />
                                        </div>
                                    )}

                                    <div className={styles.checkboxContainer}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={liquidar}
                                            onChange={() => {
                                                if (tipePayment === "PAG" && !canLiquidate) {
                                                    Swal.fire({
                                                        icon: 'warning',
                                                        title: 'Liquidación no disponible',
                                                        text: liquidationBlockMessage || 'No puede liquidar en este momento',
                                                        confirmButtonText: 'Aceptar'
                                                    });
                                                    return;
                                                }
                                                setLiquidar(!liquidar);
                                            }}
                                            id="flexCheckDefault"
                                            disabled={tipePayment === "PAG" && !canLiquidate}
                                        />
                                        <label className="form-check-label" htmlFor="flexCheckDefault" 
                                               style={{cursor: tipePayment === "PAG" && !canLiquidate ? 'not-allowed' : 'pointer',
                                                       opacity: tipePayment === "PAG" && !canLiquidate ? 0.6 : 1}}>
                                            {tipePayment === "PAG" ? "LIQUIDAR" : "APORTAR RESTANTE"}
                                        </label>
                                    </div>
                                    {tipePayment === "PAG" && !canLiquidate && liquidationBlockMessage && (
                                        <div className="alert alert-warning mt-2 mb-2" role="alert" style={{fontSize: '0.9rem'}}>
                                            <strong>⚠️ {liquidationBlockMessage}</strong>
                                        </div>
                                    )}

                                    <div className={styles.formGroup}>
                                        <label className="form-label">
                                            {tipePayment === "PAG" ? "Cantidad a recibir" : "Cantidad a aportar"}:
                                        </label>
                                        <div className={styles.monto}>
                                            {`$ ${total.toLocaleString('es-MX', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}`}
                                        </div>
                                    </div>

                                    <button
                                        className={`${styles.paymentButton} btn ${tipePayment === "PAG" ? 'btn-success' : 'btn-primary'}`}
                                        onClick={() => handlePagar()}
                                    >
                                        {tipePayment === "PAG" ? "PAGAR" : "APORTAR"}&nbsp;&nbsp;
                                        <FaMoneyBillWaveAlt />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}